// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","podcast":"_3McTl","audio":"_3deFC","download":"_2gTpQ","downloadIcon":"_1dDp7","transcription":"_28y9R"};